package com.appcreator.client.firebase.remoteconfig

import com.appcreator.blueprint.firebase.remoteconfig.FirebaseRemoteConfigCondition
import com.appcreator.blueprint.firebase.remoteconfig.FirebaseRemoteConfigConversion
import com.appcreator.compose.di.Container
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.remoteconfig.remoteConfig
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import kotlin.time.Duration.Companion.hours
import kotlin.time.Duration.Companion.minutes
import kotlin.time.Duration.Companion.seconds

object FirebaseRemoteConfigInitializer {
    fun initialize() {
        GlobalScope.launch {
            try {
                Firebase.remoteConfig.fetchAndActivate()
            } catch (ex: Exception) {
                ex.printStackTrace()
            }
        }
        firebaseRemoteConfigPlatformSetup()
        Container.registerConversion(FirebaseRemoteConfigConversion::class) {
            RemoteConfigConvertor(it)
        }
        Container.registerCondition(FirebaseRemoteConfigCondition::class) {
            RemoteConfigEvaluator(it)
        }
    }
}

expect fun firebaseRemoteConfigPlatformSetup()
